import { alwaysNotVisibleBlocks, noInputBlocks } from '@/constants';
import { useBlockStore } from '../stores/BlockStore';
import { useConfigStore } from '../stores/ConfigStore';

export default function useLastVisibleQuestionBlock(blockIds = []) {
	const { blocks } = useConfigStore();
	const blockStore = useBlockStore();

	return (
		blockIds
			.map(blockId => {
				return {
					block: blocks[blockId] ?? {},
					state: blockStore[blockId] ?? {}
				};
			})
			.filter(({ state, block }) => {
				return (
					state.isVisible &&
					alwaysNotVisibleBlocks.indexOf(block.typeName) === -1 &&
					noInputBlocks.indexOf(block.typeName) === -1
				);
			})
			.pop() ?? {
			block: {},
			state: {}
		}
	);
}
